import type { ItemTypeMeta } from "./item"
import { bindContent, contentCatalog } from "../content/catalog"
let presentation = contentCatalog.source.presentation.crafting
export let CRAFTING_GROUPS = presentation.groups
export type CraftingGroup = string
export let CRAFTING_GROUP_LABELS = presentation.labels
export let ITEM_SOURCE_HINTS = presentation.sourceHints
export const craftingGroupFor = (itemTypeMeta: ItemTypeMeta): CraftingGroup =>
    presentation.overrides[itemTypeMeta.type] ?? presentation.byClass[itemTypeMeta.class] ?? presentation.defaultGroup

bindContent(catalog => catalog.source.presentation.crafting, next => {
    presentation = next
    CRAFTING_GROUPS = next.groups
    CRAFTING_GROUP_LABELS = next.labels
    ITEM_SOURCE_HINTS = next.sourceHints
})
